module.exports = __webpack_public_path__ + "img/TelegramIcon.5cf946e.svg";